if (!customElements.get('lp-buy-box')) {
  class LpBuyBox extends HTMLElement {
    connectedCallback() {
      this.mode = this.dataset.mode === 'otp' ? 'otp' : 'sub';
      this.ctaLabel = this.dataset.ctaLabel || 'SHOP NOW';
      this.ctaLoadingLabel = this.dataset.ctaLoadingLabel || 'ADDING…';
      this.timerEl = this.querySelector('[data-timer]');

      this.handleClick = this.handleClick.bind(this);
      this.handlePageShow = this.handlePageShow.bind(this);
      this.handleAnchorClick = this.handleAnchorClick.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.tick = this.tick.bind(this);

      this.addEventListener('click', this.handleClick);
      window.addEventListener('pageshow', this.handlePageShow);
      document.addEventListener('click', this.handleAnchorClick);
      document.addEventListener('shopify:block:select', this.handleBlockSelect);

      if (this.timerEl) {
        this.expiry = this.cycleExpiry();
        this.tick();
        this.timer = window.setInterval(this.tick, 1000);
      }

      window.baCurr?.refreshConversion?.();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      window.removeEventListener('pageshow', this.handlePageShow);
      document.removeEventListener('click', this.handleAnchorClick);
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      window.clearInterval(this.timer);
    }

    /* ------------------------------------------------------------ toggle */
    handleClick(event) {
      const modeButton = event.target.closest('[data-mode-btn]');
      if (modeButton) {
        this.setMode(modeButton.dataset.modeBtn);
        return;
      }
      if (event.target.closest('[data-switch]')) {
        this.setMode(this.mode === 'sub' ? 'otp' : 'sub');
        return;
      }
      const atcButton = event.target.closest('[data-atc]');
      if (atcButton) this.addToCart(atcButton.closest('[data-tier]'), atcButton);
    }

    setMode(mode) {
      this.mode = mode === 'otp' ? 'otp' : 'sub';
      this.dataset.mode = this.mode;
      this.classList.toggle('lp-buy-box--otp', this.mode === 'otp');

      this.querySelectorAll('[data-tier]').forEach((card) => {
        const hasSub = card.querySelector('[data-state="sub"]') !== null;
        const shown = this.mode === 'sub' && hasSub ? 'sub' : 'otp';
        card.querySelectorAll('[data-state]').forEach((element) => {
          element.hidden = element.dataset.state !== shown;
        });
      });

      this.querySelectorAll('[data-sub-only]').forEach((element) => {
        element.hidden = this.mode !== 'sub';
      });
      this.querySelectorAll('[data-mode-btn]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.modeBtn === this.mode));
      });
      this.querySelector('[data-switch]')?.setAttribute('aria-checked', String(this.mode === 'sub'));
    }

    /* -------------------------------------------------------------- cart */
    goToCheckout(checkoutUrl) {
      const mercer = document.querySelector('script[data-revley-pages]');
      const path = window.location.pathname.replace(/\/+$/, '');
      const routed = mercer && mercer.dataset.revleyPages.split(',').map((p) => p.trim().replace(/\/+$/, '')).includes(path);
      if (routed && typeof window.__maybeRedirect === 'function' && window.__maybeRedirect(checkoutUrl)) return;
      window.location.assign(checkoutUrl);
    }

    addToCart(card, button) {
      if (!card || button.disabled) return;

      const item = {
        id: Number(card.dataset.variantId),
        quantity: Number(card.dataset.quantity) || 1,
      };
      if (this.mode === 'sub' && card.dataset.sellingPlan) {
        item.selling_plan = Number(card.dataset.sellingPlan);
      }

      button.disabled = true;
      button.textContent = this.ctaLoadingLabel;

      const fail = (xhr) => {
        button.disabled = false;
        button.textContent = this.ctaLabel;
        console.error('[lp-buy-box] cart request failed', xhr.status, xhr.responseText);
      };

      const routes = window.routes || {};
      const cartUrl = routes.cart_url || '/cart';
      const addUrl = `${routes.cart_add_url || '/cart/add'}.js`;
      const checkoutUrl = routes.checkout_url || '/checkout';

      // Clear first so re-entries (back button) never stack tiers: checkout
      // always mirrors exactly the tier that was clicked. The opt-out flag is
      // re-set after each step because the cart-drawer sync removes it whenever
      // it observes an empty cart.
      this.optOutOfShippingProtection();
      this.request('POST', `${cartUrl}/clear.js`, null, () => {
        this.optOutOfShippingProtection();
        this.request('POST', addUrl, { items: [item] }, () => {
          this.optOutOfShippingProtection();
          this.removeShippingProtection(cartUrl, () => {
            const abOn =
              typeof window.sofyreIsCheckoutPopupAbEnabled === 'function'
                ? window.sofyreIsCheckoutPopupAbEnabled()
                : document.documentElement.classList.contains('sofyre-enable-checkout-popup') ||
                  (document.body &&
                    document.body.classList.contains('sofyre-enable-checkout-popup'));
            const showPopup =
              this.dataset.checkoutPopupEligible === 'true' &&
              abOn &&
              window.SofyreCheckoutUpsell?.openFromCart;

            if (!showPopup) {
              this.goToCheckout(checkoutUrl);
              return;
            }

            window.SofyreCheckoutUpsell.openFromCart()
              .then((opened) => {
                if (!opened) {
                  this.goToCheckout(checkoutUrl);
                  return;
                }
                button.disabled = false;
                button.textContent = this.ctaLabel;
              })
              .catch(() => this.goToCheckout(checkoutUrl));
          });
        }, fail);
      }, fail);
    }

    // The buy box funnel skips Shipping Protection (CRO decision): the
    // cart-drawer sync auto-adds it unless this session flag is set.
    optOutOfShippingProtection() {
      try {
        sessionStorage.setItem('sofyre-shipping-protection-opt-out', 'true');
      } catch (error) {
        /* storage blocked */
      }
    }

    // Last guard before checkout: drop any Shipping Protection line the
    // cart-drawer sync managed to add between the clear and the add.
    removeShippingProtection(cartUrl, done) {
      const upsell = document.querySelector(
        'cart-drawer .shipping-protection-product[data-sofyre-managed="true"], cart-drawer [data-shipping-protection-default="true"][data-sofyre-managed="true"]'
      );
      const variantId = Number(upsell?.dataset.id);
      if (!variantId) {
        done();
        return;
      }
      this.request('GET', `${cartUrl}.js`, null, (cart) => {
        const hasLine = Array.isArray(cart?.items) && cart.items.some((line) => line.variant_id === variantId);
        if (!hasLine) {
          done();
          return;
        }
        this.request('POST', `${cartUrl}/update.js`, { updates: { [variantId]: 0 } }, done, done);
      }, done);
    }

    // XMLHttpRequest on purpose: layout/theme.liquid wraps window.fetch and
    // rewrites or strips `selling_plan` on /cart/add for any variant that is
    // also listed as a cart-drawer upsell. XHR bypasses that interceptor.
    request(method, url, body, onSuccess, onError) {
      const xhr = new XMLHttpRequest();
      xhr.open(method, url);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.onload = () => {
        if (xhr.status < 200 || xhr.status >= 300) {
          onError(xhr);
          return;
        }
        let data = null;
        try {
          data = JSON.parse(xhr.responseText);
        } catch (error) {
          /* empty or non-JSON body */
        }
        onSuccess(data);
      };
      xhr.onerror = () => onError(xhr);
      xhr.send(body ? JSON.stringify(body) : null);
    }

    handlePageShow(event) {
      // bfcache restores the page with the button frozen in its loading state.
      if (!event.persisted) return;
      this.querySelectorAll('[data-atc]').forEach((button) => {
        button.disabled = false;
        button.textContent = this.ctaLabel;
      });
      if (this.timerEl) this.expiry = this.cycleExpiry();
    }

    /* --------------------------------------------------------- countdown */
    cycleExpiry() {
      const now = Date.now();
      const fallback = Number(this.dataset.countdownFallbackMs) || 3 * 60 * 60 * 1000;
      const uid = this.dataset.countdownUid;
      if (!uid) return now + fallback;

      // Same localStorage schema as the GemPages countdown on the PDPs, so the
      // LP and the PDP show the same cycle to the same visitor.
      const domain = this.dataset.countdownDomain || window.location.hostname;
      const cacheKey = `gp:countdown-cache-time-${domain}-${uid}`;
      const settingsKey = `gp:countdown-timer-settings-${domain}-${uid}`;
      let duration = fallback;

      try {
        const settings = JSON.parse(localStorage.getItem(settingsKey) || 'null');
        if (settings && (settings.days || settings.hours || settings.mins)) {
          duration = ((settings.days || 0) * 86400 + (settings.hours || 0) * 3600 + (settings.mins || 0) * 60) * 1000;
        }
        const cache = JSON.parse(localStorage.getItem(cacheKey) || 'null');
        if (cache?.expiry > now) return cache.expiry;
        const fresh = { value: new Date(now).toString(), expiry: now + duration };
        localStorage.setItem(cacheKey, JSON.stringify(fresh));
        return fresh.expiry;
      } catch (error) {
        return now + duration;
      }
    }

    tick() {
      let seconds = Math.floor((this.expiry - Date.now()) / 1000);
      if (seconds <= 0) {
        this.expiry = this.cycleExpiry();
        seconds = Math.max(0, Math.floor((this.expiry - Date.now()) / 1000));
      }
      const pad = (value) => String(value).padStart(2, '0');
      this.timerEl.textContent = `${pad(Math.floor(seconds / 3600))}:${pad(Math.floor((seconds % 3600) / 60))}:${pad(seconds % 60)}`;
    }

    /* ------------------------------------------------------ anchor scroll */
    handleAnchorClick(event) {
      const link = event.target.closest('a[href]');
      if (!link || !this.id) return;

      let url;
      try {
        url = new URL(link.getAttribute('href'), window.location.href);
      } catch (error) {
        return;
      }
      if (url.hash !== `#${this.id}` || url.pathname !== window.location.pathname) return;

      event.preventDefault();
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const top = this.getBoundingClientRect().top + window.scrollY - this.stickyOffset() - 8;
      window.scrollTo({ top: Math.max(0, top), behavior: reducedMotion ? 'auto' : 'smooth' });
    }

    stickyOffset() {
      // The LP announcement bar today; the seasonal bar when a campaign theme is live.
      const bar = ['.announcement-bar-main', '.seasonal-announcement-bar-section']
        .map((selector) => document.querySelector(selector))
        .find((element) => element && element.offsetHeight > 0 && ['sticky', 'fixed'].includes(getComputedStyle(element).position));
      return bar ? bar.offsetHeight : 0;
    }

    /* ------------------------------------------------------------ editor */
    handleBlockSelect(event) {
      const card = this.querySelector(`[data-block-id="${event.detail?.blockId}"]`);
      card?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  customElements.define('lp-buy-box', LpBuyBox);
}
